import axios from "axios";
import {jwtDecode} from "jwt-decode";
import API_BASE_URL from "../config";

const AUTH_API = `${API_BASE_URL}/Account`; // Replace with your actual API URL

// ✅ Signup API Call
export const signup = async (userData) => {
  try {
    const response = await axios.post(`${AUTH_API}/signup`, userData);
    return response.data; // ✅ Return response directly
  } catch (error) {
    console.error("Signup Error:", error.response?.data || error.message);
    
    return { 
      Success: false, 
      Message: error.response?.data?.Message || "An error occurred during signup." 
    }; // ✅ Instead of throwing, return an object
  }
};

// ✅ Login API Call
export const login = async (credentials) => {
  try {
    const response = await axios.post(`${AUTH_API}/login`, credentials);


    if (response.data.success) {
      localStorage.setItem("token", response.data.token); // ✅ Store JWT Token
      localStorage.setItem("userId", response.data.userId); // ✅ Store JWT Token
    }

    return response.data; // ✅ Return response directly
  } catch (error) {
    console.error("Login Error:", error.response?.data || error.message);
    
    return { 
      Success: false, 
      Message: error.response?.data?.Message || "Invalid login credentials." 
    };
  }
};

// ✅ Logout Function
export const logout = () => {
  localStorage.removeItem("token"); // ✅ Remove JWT Token
};


// // ✅ Check if User is Logged In
// export const isAuthenticated = () => {
//   return !!getAuthToken(); // ✅ Returns true if token exists, else false
// };

export const forgotPassword = async (userData) => {
  try {
    const response = await axios.post(`${AUTH_API}/ForgotPassword`, userData);
    return response.data; // ✅ Return response directly
  } catch (error) {
    console.error("Error:", error.response?.data || error.message);
    
    return { 
      Success: false, 
      Message: error.response?.data?.Message || "An error occurred." 
    }; // ✅ Instead of throwing, return an object
  }
};

export const resetPassword = async (userData) => {
  try {
    const response = await axios.post(`${AUTH_API}/ResetPassword`, userData);
    return response.data; // ✅ Return response directly
  } catch (error) {
    console.error("Error:", error.response?.data || error.message);
    
    return { 
      Success: false, 
      Message: error.response?.data?.Message || "An error occurred." 
    }; // ✅ Instead of throwing, return an object
  }
};

export const getUserIdFromToken = () => {
  const token = localStorage.getItem("token"); // ✅ Get token from localStorage
  if (!token) return null;

  try {
      const decodedToken = jwtDecode(token); // ✅ Decode token
      return decodedToken.userId || null; // ✅ Extract userId
  } catch (error) {
      console.error("Invalid token:", error);
      return null;
  }
};
